var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#e79831","width":7,"size":70}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }